export const useFromMobile = (): boolean => {
  return sessionStorage.getItem('fromMobile') === 'true';
};
